import { binder } from "./libs/binder";
import { staticFunctions } from "./modules/module";
import { common } from "./modules/common";
import { mmenu } from "./modules/mobile-menu";
import { hero } from "./modules/hero";
import { sliders } from "./modules/sliders";
import { loadMore } from "./modules/load-more";

binder({
  bounds: {
    "body": [staticFunctions.addDevicesClasses(), staticFunctions.setBrowserInfo(), common, mmenu],
    ".hero": [hero],
    ".slider-wrapper": [sliders],
    ".load-more-wrapper": [loadMore]
  },
  runTests: false
});


// WEBPACK FOOTER //
// ./assets/js/global.js